// extracted by mini-css-extract-plugin
export default {"tableFooter":"FlexPassTable_tableFooter__vNcRx","tableHead":"FlexPassTable_tableHead__8zHSp"};